// import { useQuery } from "react-admin"
import { useDataProvider, useNotify } from 'react-admin';
// import Parse from "Parse"
export const useCertificationsCreate = (payload) => {
    const dataProvider = useDataProvider();
    const notify  = useNotify()
    // console.log("values", values);
    //   const [open, setOpen] = React.useState(true);

    // const [createCertificate, data] = useMutation(
    //     {
    //         type: 'create',
    //         resource: 'Certification',
    //         payload: payload,
    //     });
    return {
        createCertification: async(payload) => {
            const data = await dataProvider.create('Certification', {
                data:{
                    certificateName: payload.certificateName
                }
            })
            notify('Add a certification')
            return data
        }
    }
}
